import { default as COLORS } from '../../../../theme/colors';

const APP_COLORS = {

  primary: '#0040DB',
  secondary: '#E145FF',
  tertiary: '#627A96',

  negative: '#FF3A47',
  warning: '#FDD430',
  success: '#00D689',

  to_grid: '#FBE9AE',
  production: '#FAE294',
  export: '#FAE294',
  to_shared: '#F9DA74',
  
  from_grid: '#FFDADA',
  consumption: '#FFC2C2',
  import: '#FFC2C2',
  from_shared: '#FFB4B4',

  self_consumption_battery: '#BFCFF6',
  production_to_battery: '#94AEF0',
  battery_soc: '#809FED',
  total_battery: '#94AEF0',
  
  self_consumption: '#A8C2BB',

  total_shared: '#8091B2',
  total_grid: '#C0C8D8',

  revenues: '#0F306E',
  savings: '#4B6492', 
  cost_1: '#0F306E',
  cost_2: '#4B6492', 

};

export default {
  ...COLORS,
  ...APP_COLORS,
};
